import { useContext } from 'react';
import Moment from 'react-moment';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { dashboardContext } from './DashboardContext';
import Content from './Content';


let OrderChannelsDashboard = () => {

    let { orderChannels } = useContext(dashboardContext);

    return (
        <Content title='Orders per channel, last 3 months'>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Channel</TableCell>
                        <TableCell>Order</TableCell>
                        <TableCell>Order date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orderChannels.map((order, index) =>
                        <TableRow hover key={index} sx={{ height: 60, maxHeigh: 60 }}>
                            <TableCell>{order.channelDescription}</TableCell>
                            <TableCell>
                                {order.orderId &&
                                    <Link component={RouterLink} to={`/order/${order.id}`}>{order.orderId}</Link>
                                }
                                {order.orderId == null &&
                                    <span>No orders for this channel</span>
                                }
                            </TableCell>
                            <TableCell>
                                {order.orderDate && <Moment date={order.orderDate} format="LLL" />}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {orderChannels.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <Typography variant="subtitle2">No orders found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </Content>
    )
}

export default OrderChannelsDashboard;